import { Stack } from "@fluentui/react";
import React from "react";
import { useSelector } from "react-redux";
import { cafeSelector } from "../selectors/diningSelector";
import CafeSelector from "./CafeSelector/CafeSelector";
import GettingStarted from "./GettingStarted";
import StationImageList from "./StationImages/StationImageList";

export default () => {
  const selectedCafe = useSelector(cafeSelector);

  return (
    <Stack horizontal={true} verticalFill={true} role="main">
      <Stack.Item className={"cafeSelector"} verticalFill={true} grow={false}>
        <CafeSelector />
      </Stack.Item>
      <Stack.Item className={"imageManagementContent"} grow={true}>
        <Stack verticalFill={true} verticalAlign="start">
          {selectedCafe ? (
            <StationImageList />
          ) : (
            <GettingStarted instructions={"Then you can start editing station images."} />
          )}
        </Stack>
      </Stack.Item>
    </Stack>
  );
};
